import { GET_ADDRESS_TYPES } from '../actions/types';

const initialState = {
  list: []
};

export default function(state = initialState, action = {}) {
  switch (action.type) {
    case GET_ADDRESS_TYPES: {
      return { ...state, ...{ list: action.addressTypesData } };
    }
    default:
      return state;
  }
}
